import React from "react";
import OfferDetailsBase from "./OfferDetailsBase";

export default function RentalDetails() {
  return <OfferDetailsBase kind="rental" />;
}
